module.exports = __webpack_public_path__ + "e9355c55a7cf9c2244acc4d9fec020e6.svg";